import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { TextField } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/styles';
import messages from 'containers/CourtManagerLegalProceedings/JudgementAdd/messages';
import SahamDialog from 'components/SahamDialog';
import DecisionDialog from 'components/DecisionDialog/index';
import {
  formatIncomePayloadToUpdate,
  formatPayloadToMakeDecision,
} from 'containers/common/LegalProceedings/JudgementAdd/Recap/IncomeCertificatesRecap/utils';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';

export interface ValidationDialogProps {
  intl: IntlShape;
  sagisVictimInfo: any;
  requestUpdateIncomeCertificate?: Function;
  isManager: Boolean;
  claimId: number;
  claimNumber: string;
  open: boolean;
  handleClose: any;
  judiciaryProcessId: any;
  incomeCertificate: any;
  toUpdate?: boolean;
  requestMakeDecisionIncomeCertificate?: Function;
  status?: string;
  riskKey: string;
  claim: any;
  judgementAdd: any;
  dahirAmount: any;
}

export const ValidationDialog: React.FC<ValidationDialogProps> = (
  props,
): JSX.Element => {
  const [reason, setReason] = React.useState(null);
  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };
  const handleValidate = () => {
    const { victim, ...rest } = props.incomeCertificate;
    if (props.toUpdate && props.requestUpdateIncomeCertificate) {
      const payloadToUpdate = formatIncomePayloadToUpdate(
        rest,
        props.claimNumber,
        props.claimId,
        props.judiciaryProcessId,
        victim,
        props.isManager,
        props.dahirAmount,
        get(props.claim, 'victims', []),
        props.claim,
        props.riskKey,
      );
      props.requestUpdateIncomeCertificate(
        payloadToUpdate,
        successCallBackUpdate,
      );
    } else if (
      props.status &&
      props.requestMakeDecisionIncomeCertificate &&
      props.isManager
    ) {
      const payloadToMakeDecision = formatPayloadToMakeDecision(
        rest,
        props.status,
        props.riskKey,
        props.claimId,
        props.judiciaryProcessId,
        props.isManager,
        victim,
        props.dahirAmount,
        props.claim,
        get(props.claim, 'victims'),
        reason,
      );
      props.requestMakeDecisionIncomeCertificate(
        payloadToMakeDecision,
        successCallBackDecision,
      );
    }
  };
  const successCallBackUpdate = () => {
    toast.success(translate(messages.updateIncomeCertificateSucess, props));
    props.handleClose();
  };
  const successCallBackDecision = () => {
    toast.success(translate(messages.validationToastSuccess, props));
    props.handleClose();
  };
  const renderContent = () => {
    if (props.status && props.status === STATUS_REJECTED) {
      return (
        <DecisionDialog
          open={props.open}
          onClose={props.handleClose}
          validateDialog={handleValidate}
          title={translate({ ...messages.decisionTitle }, props)}
          content={
            <StyledDiv>
              <TextField
                onChange={handleChangeReason}
                name={'reason'}
                value={reason}
                label={translate({ ...messages.reason }, props)}
                className="input"
                multiline
                fullWidth
              />
            </StyledDiv>
          }
          disabled={!reason}
          primaryButtonTitle={translate(messages.dialogValidationButton, props)}
          scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
        />
      );
    } else {
      return (
        <SahamDialog
          handleValidate={handleValidate}
          handleClose={props.handleClose}
          title={translate(messages.courtManagerConfirmationDialogTitle, props)}
          cancelTitle={translate(
            messages.courtManagerConfirmationDialogCancel,
            props,
          )}
          confirmTitle={translate(
            messages.courtManagerConfirmationDialogConfirm,
            props,
          )}
          open={props.open}
        >
          {translate(messages.courtManagerConfirmationDialogContent, props)}
        </SahamDialog>
      );
    }
  };
  return <>{renderContent()}</>;
};

export default injectIntl(ValidationDialog);
